import { Pipe, PipeTransform } from "@angular/core";
import { PaymentTypes } from "../models/system.model";

@Pipe({
  name: "NoBilling",
})
export class NoBillingPipe implements PipeTransform {
  transform(value: PaymentTypes, args?: any): any {
    if (value) {
      return (
        value.SelfPayable === "0" &&
        value.ClientBillable === "0" &&
        value.InsuranceBillable === "0"
      );
    } else {
      return true;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/show-payment.pipe.ts